import { StateReducer, useCreateReducer } from "@/libs/reducer";
import { useGlobalVerify } from "@/logic/verify";
import { useLockFn } from "ahooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { payUserDeposit } from "@/apis/user";
import { Toast } from "antd-mobile";

/**
 * 使用 Turn Interface to Object 插件去直接成 pagestate
 */
interface PageState {}

const pagestate = {};

type ActionType = "update-hello";

const stateReducer: StateReducer<PageState, ActionType> = (state, action) => {
  switch (action.type) {
    case "update-hello":
      return Object.assign({}, state, {});

    default:
      return state;
  }
};

export const useSetup = () => {
  const navigate = useNavigate();
  const [serach, setSearch] = useSearchParams({
    orderNo: "",
    amount: "",
  });
  const [state, dispatch] = useCreateReducer<PageState, ActionType>(
    stateReducer,
    pagestate,
    {}
  );

  const [verifySecurePassword] = useGlobalVerify();

  const toPay = useLockFn(async () => {
    const code = await verifySecurePassword();

    const result = await payUserDeposit({
      orderNo: serach.get("orderNo"),
      securePassword: code,
    });
    if (result.ok) {
      Toast.show(result.msg);
      navigate("/");
    } else {
      Toast.show(result.msg);
    }
  });

  return { state, dispatch, navigate, serach, toPay };
};
